import styled from '@emotion/styled'

const StyledMenuContainer = styled.div`
  .small-block {
    height: 56px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 14px 22px;
    background: var(--ow-color-white-100);
    .tree-nav-icon {
      cursor: pointer;
    }
  }
`
const StyledMenuOperate = styled.div`
  display: flex;
  align-items: center;
  /* min-height: 56px; */
  background: var(--ow-color-white-100);
  padding: 0 16px;
`
const StyledMenuContent = styled.div`
  position: relative;
  // 导航列表可视部分
  .menu-content {
    height: 56px;
    overflow: auto;
    display: flex;
    align-items: center;
    &::-webkit-scrollbar {
      display: none;
    }
    scroll-behavior: smooth;
  }
  // 上一页/下一页 按钮
  .scroll-btn {
    padding: 20px 12px;
    cursor: pointer;
    position: relative;
  }
  .left-arrow-btn {
    border-right: 1px solid var(--ow-color-neutral-300);
    box-shadow: 16px 0 24px 0 rgba(0, 0, 0, 0.1);
  }
  .right-arrow-btn {
    border-left: 1px solid var(--ow-color-neutral-300);
    box-shadow: -16px 0 24px 0 rgba(0, 0, 0, 0.1);
  }
`
const StyledMenuContentItem = styled.div`
  .nav-name {
    font-size: 14px;
    padding: 3.5px 16px;
    cursor: pointer;
    white-space: nowrap;
  }
  .nav-item-active {
    border-radius: 14px;
    background: var(--ow-color-primary-700);
    color: var(--ow-color-white-100);
    font-weight: bold;
  }
`
export {
  StyledMenuContainer,
  StyledMenuContent,
  StyledMenuContentItem,
  StyledMenuOperate,
}
